<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.unQaWorkerOrders')]"></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <!-- <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('workOrder.serialNo')"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-autocomplete
            size="small"
            v-model.trim="searchForm.serialNo"
            :fetch-suggestions="querySearchSerialNo"
            :trigger-on-focus="false"
            style="width: 100%"
            clearable
            :placeholder="$t('text.serialNo')"
            @select="handleSelectSerialNo"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button class="button-blue" size="mini" @click="receiveAndScan">
              {{ $t("action.receiveAndScan") }}
            </el-button>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="workOrdersTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              <span v-if="row.workflowState != 'canceled'">
                <span
                  v-if="row.voidAt == null && row.jyOrderCancelAt == null"
                  >{{ row.serialNo }}</span
                >
                <s v-if="row.voidAt != null && row.jyOrderCancelAt == null">{{
                  row.serialNo
                }}</s>

                <s
                  v-if="row.voidAt == null && row.jyOrderCancelAt != null"
                  class="grey"
                  >{{ row.serialNo }}</s
                >
              </span>
              <span v-if="row.workflowState == 'canceled'" class="grey">
                {{ row.serialNo }}
              </span>
            </a>
            <div class="font10">{{ row.orderInnerSerialNo }}</div>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("workOrderStates." + row.workflowState) }}
              </state-label>
              <small v-if="row.pausedAt != null" class="orange">{{
                $t("text.stop")
              }}</small>
              <span v-if="row.orderBargainId == null" class="orange font10">
                {{ $t("order.replenish") }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="factoryName"
          :title="$t('menu.factories')"
          min-width="80"
        />
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div class="font10">
              {{ row.terminalCustomerName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.orderCustomerProductNo != null &&
                row.orderCustomerProductNo != ''
              "
              >({{ row.orderCustomerProductNo }})</small
            >
            <div class="font10">
              {{ row.category }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
            <div v-if="row.qaQuantity" class="font10">
              {{ $t("action.qa") }}:{{ row.qaQuantity }}
            </div>
            <div v-if="row.shipQuantity" class="font10">
              {{ $t("workOrder.ship") }}:{{ row.shipQuantity }}
              <span
                v-if="
                  row.shipForceQuantity != null && row.shipForceQuantity != 0
                "
              >
                ({{ $t("workOrder.shipForceQuantity") }}:{{
                  row.shipForceQuantity
                }})
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        />
        <vxe-table-column :title="$t('text.handle')" min-width="80">
          <template v-slot="{ row }">
            {{ row.handler }}
            <div class="font10">{{ row.handleDepart }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="processedAt"
          :title="$t('workOrder.processedAt')"
          width="120"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="8"
              type="richText"
            />
            <div>
              <attribute :content="row.spec" :number="8" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="70"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="
                row.orderBargainId == null &&
                row.quantity -
                  row.qaQuantity -
                  row.shipQuantity +
                  row.shipForceQuantity >
                  0
              "
              type="text"
              size="mini"
              @click="receiveChangeSize(row)"
            >
              {{ $t("action.receiveChangeSize") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <drawer
      :title="$t('text.view', [$t('menu.workOrders')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <el-dialog
      :title="$t('action.receiveAndScan')"
      width="60%"
      v-if="receiveAndScanDF"
      :visible.sync="receiveAndScanDF"
      :close-on-click-modal="false"
    >
      <batch-receive
        :items="selectRecords"
        @close="receiveAndScanDF = false"
        @updateData="receiveAndScanClose"
      ></batch-receive>
    </el-dialog>

    <!-- 改码收货 -->
    <el-dialog
      :title="$t('action.receiveChangeSize')"
      :visible.sync="receiveChangeSizeDF"
      width="30%"
    >
      <el-form
        ref="receiveChangeSizeObjForm"
        :model="receiveChangeSizeObj"
        label-width="70px"
      >
        <el-form-item :label="$t('product.size')" :prop="'size'">
          <el-autocomplete
            size="small"
            v-model="receiveChangeSizeObj.size"
            :fetch-suggestions="querySearchSize"
            style="width: 100%"
            @select="handleSelectSize"
          />
        </el-form-item>
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model="receiveChangeSizeObj.quantity"
            :placeholder="receiveChangeSizeObj._maxQuantity"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="receiveChangeSizeSubmitDoing"
          size="small"
          @click="receiveChangeSizeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="receiveChangeSizeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import WorkOrder from "@/api/workOrder.js";
import Product from "@/api/product.js";

import Show from "./show";
import BatchReceive from "./batchReceive";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
    BatchReceive,
  },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("text.workflowState"),
            items: WorkOrder.states_receive.map((s) => {
              return {
                key: s,
                label: this.$t("workOrderStates." + s),
                condition: { workflowState: s },
              };
            }),
          },
        ],
      ],
      sorter: {
        sortBy: "workOrders_id",
        sortIndicator: "desc",
      },
      initFilter: null,
      searchForm: {
        keyword: null,
        serialNo: null,
        productNo: null,
        handle: null,
        customerName: null,
      },
      //
      show: false,
      currentRowId: null,
      //
      receiveAndScanDF: false,
      // 改码收货
      row: null,
      shops: [],
      shopsInv: [],
      receiveChangeSizeDF: false,
      productNoSizes: [],
      receiveChangeSizeObj: {
        workOrderId: null,
        quantity: null,
        size: null,
        factoryName: null,
        _maxQuantity: null,
      },
      receiveChangeSizeSubmitDoing: false,
      serialNos: [],
    };
  },

  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
  },

  methods: {
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      WorkOrder.vagueSerialNo({ serialNo: queryString }).then(function (res) {
        const ps = res.data;
        self.serialNos = ps.map((p) => {
          return { value: p };
        });
        cb(self.serialNos);
      });
    },
    handleSelectSerialNo() {},
    // 改码收货
    receiveChangeSize(row) {
      const self = this;
      self.row = row;
      self.receiveChangeSizeObj.workOrderId = row.id;
      self.receiveChangeSizeObj.factoryName = row.factoryName;
      self.receiveChangeSizeObj.size = null;
      // self.receiveChangeSizeObj._maxQuantity =
      //   row.quantity -
      //   (row.shipQuantity || 0) -
      //   (row.qaQuantity || 0) +
      //   (row.shipForceQuantity || 0);
      self.receiveChangeSizeObj._maxQuantity = row.canForceReceiveQuantity;

      self.receiveChangeSizeObj.quantity =
        self.receiveChangeSizeObj._maxQuantity;
      self.receiveChangeSizeSubmitDoing = false;
      axios
        .all([Product.findByProductNo({ productNo: self.row.productNo })])
        .then(
          axios.spread(function (product) {
            if (product.data.code === 200) {
              self.productNoSizes = product.data.entity.sizes;
            } else {
              self.sysError();
            }
            self.receiveChangeSizeDF = true;
          })
        );
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      if (queryString == null) {
        cb(
          self.productNoSizes.map((s) => {
            return { value: s };
          })
        );
      } else {
        const filterSizes = self.productNoSizes.filter(
          (c) => c.indexOf(queryString) !== -1
        );
        cb(
          filterSizes.map((s) => {
            return { value: s };
          })
        );
      }
    },
    handleSelectSize() {},

    receiveChangeSizeSubmit() {
      const self = this;
      self.$refs.receiveChangeSizeObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.receiveChangeSizeObj.quantity) ||
            self.receiveChangeSizeObj.quantity == "0" ||
            self.receiveChangeSizeObj.quantity >
              self.receiveChangeSizeObj._maxQuantity
          ) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.receiveChangeSizeObj.size = Util.jyTrim(
            self.receiveChangeSizeObj.size
          );
          self.receiveChangeSizeSubmitDoing = true;
          WorkOrder.changeSpecsForeceReceive(self.receiveChangeSizeObj).then(
            function (res) {
              self.receiveChangeSizeSubmitDoing = false;
              self.receiveChangeSizeDF = false;
              if (res.status === 200) {
                self.loadData();
                self.sysResult(res.data);
                self.$eventHub.$emit("WorkOrderChangeSpecsForeceReceive");
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 收货
    receiveAndScan() {
      this.receiveAndScanDF = true;
    },
    receiveAndScanClose() {
      this.loadData();
      this.receiveAndScanDF = false;
    },

    // 可选
    checCheckboxMethod({ row }) {
      const maxReceiveQty =
        row.quantity -
        (row.shipQuantity || 0) -
        (row.qaQuantity || 0) +
        (row.shipForceQuantity || 0);
      if (maxReceiveQty > 0) {
        return true;
      }
      return false;
    },

    //
    showRecord(row) {
      this.currentRowId = row.id;
      this.show = true;
    },
    //======
    dataProvider(params) {
      return WorkOrder.receiveSearch(params);
    },
  },
};
</script>

<style scoped>
</style>